var initializeBlockRegionMap = function(block){
    
    jQuery(".wp-block-region-map .region:eq(0), .regions > div:eq(0)").addClass("active").show();

      jQuery(".wp-block-region-map .region").click(function(){

          var menuItem = jQuery(this);
          
          menuItem.siblings(".active").removeClass("active");
          menuItem.addClass("active");
          
          var index = menuItem.index();
          
          jQuery(".regions > .active").removeClass("active").hide();
          jQuery(".regions > div:eq("+index+")").addClass("active").show();
          
      });
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-region-map').each(function(){
        initializeBlockRegionMap(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=region-map', initializeBlockRegionMap);
